export default {
  selectedWithCount: '{number} selecionados',
  shareEntireDirectory: 'Compartilhar Diretório Inteiro',
  afterOpenTips:
    'Após a abertura, todo o conteúdo deste diretório será compartilhado (o novo conteúdo no diretório também será compartilhado automaticamente no futuro)',
  afterOpenTipsTwo:
    'Todo o conteúdo de todo o diretório será compartilhado (o novo conteúdo neste diretório também será compartilhado automaticamente no futuro)',
  noContent: 'Sem Conteúdo',
  selectAll: 'Selecionar tudo',
  all: 'Todos',
  notSelectAnyWithName: 'Nenhum {name} selecionado',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  customExpression: 'Expressão Personalizada',
  noPermission: 'Permissões insuficientes',
  enumeratedValue: 'Enumerações',
  description: 'Descrição',
  required: 'Necessário',
  optional: 'Opcional',
  default: 'Padrão',
  length: 'Tamanho',
  format: 'Formato',
  enum: 'Enum',
  regexp: 'Regexp',
  and: 'e',
  value: 'Valor',
  arrayLength: 'Tamanho',
  uniqueItems: 'Item Único',
  additionalItems: 'Itens Adicionais',
  additionalProperties: 'Propriedades Adicionais',
  const: 'Const',
  multipleOf: 'Múltiplo de {multipleOf}',
  propertiesLength: 'Número de propriedades',
  writeOnly: 'Somente Escrita',
  readOnly: 'Somente Leitura',
  examples: 'Exemplos',
  externalDocs: 'Documentos Externos',
  isCopied: 'Copiado',
  copyToClipboard: 'Copiar para a área de transferência',
  'overView.isCopied': 'Copiado',
  'overView.failToCopied': 'Falha ao copiar, registre manualmente o seguinte conteúdo',
  'component.tagSelect.expand': 'Expandir',
  'component.tagSelect.collapse': 'Recolher',
  deprecated: 'descontinuado',
  'error.url': 'URL inválido: {url}',
  note: 'NOTA',
  tip: 'DICA',
  info: 'INFORMAÇÃO',
  caution: 'CUIDADO',
  danger: 'PERIGO',
  warning: 'AVISO',
  check: 'VERIFICAR',
  name: 'Name',
  'codeEditor.copy': 'Copiar',
  'codeEditor.format': 'Embelezar',
  'codeEditor.showEditor': 'Mostrar Conteúdo',
  'schemaGenerator.codeGenerate': 'Gerar código de esquema',
  'schemaGenerator.more': 'Mais',
  'schemaGenerator.name': 'Nome',
  'schemaGenerator.commaSeparator': ', ',
  'codeEditor.wrap': 'Quebrar',
  'inbox.MarkAllAsRead': 'Marcar tudo como lido',
  'environment.manageModal.tip.clickToSetVariable': 'Clique para definir a variável: ',
  'environment.variable.notSet': 'Não definido',
  'httpCode.shortName.200': 'OK',
  'httpCode.shortName.201': 'Criado',
  'httpCode.shortName.202': 'Aceito',
  'httpCode.shortName.204': 'Sem Conteúdo',
  'httpCode.shortName.400': 'Pedido inválido',
  'httpCode.shortName.401': 'Não autorizado',
  'httpCode.shortName.403': 'Proibido',
  'httpCode.shortName.404': 'Registro não encontrado',
  'httpCode.shortName.410': 'Registro inexistente',
  'httpCode.shortName.422': 'Erro de parâmetro',
  'httpCode.shortName.500': 'Erro do servidor',
  'httpCode.shortName.502': 'Gateway incorreto',
  'httpCode.shortName.503': 'Serviço indisponível',
  'httpCode.shortName.504': 'Timeout gateway',
};
